import React, { FC, useState } from "react";
import styled from "styled-components";
import ipad from "../../assets/ipad.png";
import { lightTheme } from "../../styles/theme";
import Modal from "@mui/material/Modal";
import { fadeIn } from "../../styles/styles";
import { useTranslation } from "../../lang/TranslationContext";

type VideoModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const VideoModal: FC<VideoModalProps> = ({ open, setOpen }) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Content>
        <iframe
          loading="lazy"
          src="https://www.youtube.com/embed/PnFXLLlqPtc?si=zcf6xbtwQmF0MjRH"
          title="MarketEcho Demo"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
      </Content>
    </Modal>
  );
};

const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px;
  background: #000;
  border-radius: 20px;
  width: 100%;
  height: 100%;
  max-width: 1200px;
  max-height: 800px;
  outline: none;
  animation: ${fadeIn} 0.3s;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 16px;
    animation: ${fadeIn} 0.7s;
  }

  @media screen and (max-width: 1300px) {
    max-width: 1000px;
    max-height: 670px;
  }

  @media screen and (max-width: 1100px) {
    max-width: 700px;
    max-height: 465px;
  }

  @media screen and (max-width: 850px) {
    max-width: 500px;
    max-height: 333px;
  }

  @media screen and (max-width: 650px) {
    max-width: 350px;
    max-height: 230px;
  }
`;

export const Demo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { translations } = useTranslation();

  return (
    <>
      <VideoModal open={isOpen} setOpen={setIsOpen} />
      <Wrap>
        <InnerWrap>
          <h1>{translations.landing.demo.heading}</h1>
          <p>
            {translations.landing.demo.subheading1}
            {translations.landing.demo.subheading2}
          </p>
          <div>
            <i onClick={() => setIsOpen(true)} className="pi pi-play-circle" />
            <img onClick={() => setIsOpen(true)} src={ipad} alt="ipad" />
          </div>
        </InnerWrap>
      </Wrap>
    </>
  );
};

const Wrap = styled.div`
  width: 100%;
  max-height: 100vh;
  background: ${lightTheme.typography.primary};
  display: flex;
  justify-content: center;
`;

const InnerWrap = styled.div`
  max-width: 1440px;
  overflow: hidden;
  padding: 100px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-top: 20px;
    width: 100%;
    font-size: 42px;
    color: white;
    font-weight: 700;
    line-height: 1;

    @media screen and (max-width: 700px) {
      font-size: 30px;
    }
  }

  p {
    margin-top: 15px;
    width: 100%;
    font-size: 18px;
    color: white;
    font-weight: 400;

    span {
      color: #047857;
    }

    @media screen and (max-width: 700px) {
      font-size: 16px;
    }
  }

  div {
    width: 100%;
    max-height: 80vh;
    position: relative;
    margin-top: 15px;

    &:hover {
      i {
        color: #000000;
      }
      img {
        filter: brightness(100%);
        transform: scale(1.01);
      }
    }

    i {
      font-size: 60px;
      color: white;
      transition: 0.5s;
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }

    img {
      cursor: pointer;
      object-fit: contain;
      height: 100%;
      width: 100%;
      transition: 0.5s;
      filter: brightness(85%);
      display: block;
    }
  }
`;
